<template>
  <div class="product-slideshow">
    <CommonSlideshow slide-component="CommonSlideImage" :slides="getSlides" />
  </div>
</template>

<script>
import CommonSlideshow from '../common/CommonSlideshow.vue'

export default {
  components: {
    CommonSlideshow,
  },
  props: {
    product: Object,
  },
  computed: {
    getSlides() {
      return this.product.images
    },
  },
}
</script>

<style lang="scss">
@import '~/styles/base';
.product-slideshow {
  .global-slideshow {
    &__controls {
      @include respond-to('m') {
        margin-top: -60px;
        z-index: 100;
        padding-bottom: 40px;
        position: relative;
      }
    }
  }
}
</style>